import React from 'react';
import { getiTrustRequests } from '~/javascripts/admin/actions/itrust-requests';
import { formatDate } from '~/javascripts/admin/utils';
import Table from '../../atoms/Table';
import Pager from '../../shared/Pager';

type Props = {
  iTrustRequests?: Awaited<ReturnType<typeof getiTrustRequests>>;
  onChangePage: (page: number) => void;
};

type Header = {
  label: string;
  size: number;
  align?: 'center' | 'justify' | 'left' | 'right';
  tooltipKey?: string;
  tooltipText?: string | React.ReactNode;
};

const headers: Header[] = [
  { label: 'ID', size: 1 },
  { label: 'マネー名', size: 3 },
  { label: '組織名', size: 3 },
  { label: 'ニックネーム', size: 3 },
  { label: '作成日時', size: 2 },
];

const ListTable = ({ iTrustRequests, onChangePage }: Props) => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          {headers.map((c) => (
            <Table.Cell size={c.size} key={c.label}>
              {c.label}
            </Table.Cell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {iTrustRequests?.rows?.map((request) => (
          <Table.Row key={request.id}>
            <Table.Cell wordBreak="keep-all">{request.id}</Table.Cell>
            <Table.Cell>{request.private_money_name}</Table.Cell>
            <Table.Cell>{request.organization.name}</Table.Cell>
            <Table.Cell>{request.user.name}</Table.Cell>
            <Table.Cell wordBreak="keep-all">{formatDate(request.created_at)}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row noBorder>
          <Table.Cell colSpan={headers.length} align="center" styles={{ paddingTop: '16px' }}>
            <Pager pagination={iTrustRequests?.pagination} onChangePage={onChangePage} />
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default ListTable;
